export default __webpack_public_path__ + "static/media/blue3.d3e372a5.png";